import { render, staticRenderFns } from "./ledger_list.vue?vue&type=template&id=70aad89c&scoped=true&"
import script from "./ledger_list.vue?vue&type=script&lang=js&"
export * from "./ledger_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aad89c",
  null
  
)

export default component.exports